// TODO: Pending migration

export const RegisterPage = {
  templateUrl: './app/_pages/register/register-page.html',
  bindings: {},
  controller: RegisterPageController,
  controllerAs: 'vm',
};

RegisterPageController.$inject = [
  'CONFIGURATIONS',
  '$location',
  'UtilService',
  'UserService',
  'SessionService',
];

function RegisterPageController(config, $location, UtilService, UserService, SessionService) {
  // User is logged
  if (SessionService.isLoggedIn()) {
    $location.path('/'); // { reload: true }
    return;
  }

  var vm = this;

  vm.UtilService = new UtilService(vm);

  vm.countryOptions = config.COUNTRIES;

  vm.user = {};

  vm.submit = function (isFormValid) {
    vm.formErrors = false;

    if (!isFormValid) {
      vm.serverErrors = [];
      vm.formErrors = true;
    } else {
      vm.sendingForm = true;
      setTimeout(function () {
        UserService.registerUserAccount(vm.user).then(function (data) {
          var status = data.status;
          var response = data.response;

          if (!status) {
            // Error
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        });
      }, 500);
    }
  };
}
